import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './CharacterCounter.styled';
import { VisuallyHiddenText } from '../../styles/mixins/visually-hidden';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CharacterCounter = _ref => {
  let {
    id,
    textLength,
    maxCharactersAllowed
  } = _ref;
  const {
    t
  } = useTranslation('blocks.textarea');
  let label = t('CharacterCounter.label.allowed', {
    count: maxCharactersAllowed,
    defaultValue: '{{count}} characters allowed'
  });
  if (textLength > 0 && textLength <= maxCharactersAllowed) {
    const charactersLeft = maxCharactersAllowed - textLength;
    label = t('CharacterCounter.label.left', {
      count: charactersLeft,
      defaultValue: '{{count}} characters left'
    });
  } else if (textLength > maxCharactersAllowed) {
    const charactersOver = textLength - maxCharactersAllowed;
    label = t('CharacterCounter.label.overLimit', {
      count: charactersOver,
      defaultValue: '{{count}} characters over limit'
    });
  }
  return /*#__PURE__*/_jsxs(Styled.CharacterCounterContainer, {
    id: id,
    "aria-live": "polite",
    children: [/*#__PURE__*/_jsx(VisuallyHiddenText, {
      children: label
    }), /*#__PURE__*/_jsx("span", {
      "aria-hidden": "true",
      children: t('CharacterCounter.readout', {
        textLength,
        maxCharactersAllowed,
        defaultValue: '{{textLength}} / {{maxCharactersAllowed}}'
      })
    })]
  });
};